import { TypePopup, useUpsellStore } from '@/store/upsell'
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'
export const useSetActivePopupUpsell = () => {
  const { type, setShowFixedPopupUpsell } = useUpsellStore()
  const pathname = usePathname()

  useEffect(() => {
    if (!pathname?.includes('/payment/success') && type === TypePopup.UPSELL) {
      setShowFixedPopupUpsell(true)
    }
  }, [pathname, setShowFixedPopupUpsell, type])
}

export const useUnsetActivePopupUpsell = () => {
  const { setShowFixedPopupUpsell } = useUpsellStore()
  useEffect(() => {
    // Hide upsell popup on payment success page
    setShowFixedPopupUpsell(false)
    // Cleanup: show it again when leaving the page
    // return () => {
    //   setShowFixedPopupUpsell(true)
    // }
  }, [setShowFixedPopupUpsell])
}